import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId/workspace/records/$recordId/_drawer/attachments",
)({
	beforeLoad: ({ location }) => {
		throw redirect({
			href: `${location.pathname.replace(/\/attachments\/?$/, "/details")}${location.searchStr ?? ""}${location.hash ?? ""}`,
			replace: true,
		});
	},
});
